export const portfolio = [
  {
    img: "/excursions/photo41.jpg",
    head: "portfolio.items.4.title",
    desc: "portfolio.items.4.date",
    color: "#3E3A34"
  },
  {
    img: "/excursions/photo42.jpg",
    head: "portfolio.items.4.title",
    desc: "portfolio.items.4.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo43.jpg",
    head: "portfolio.items.4.title",
    desc: "portfolio.items.4.date",
    color: "#3E3A34"
  },
  {
    img: "/excursions/photo31.jpg",
    head: "portfolio.items.3.title",
    desc: "portfolio.items.3.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo32.jpg",
    head: "portfolio.items.3.title",
    desc: "portfolio.items.3.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo33.jpg",
    head: "portfolio.items.3.title",
    desc: "portfolio.items.3.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo23.jpg",
    head: "portfolio.items.2.title",
    desc: "portfolio.items.2.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo22.jpg",
    head: "portfolio.items.2.title",
    desc: "portfolio.items.2.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo21.jpg",
    head: "portfolio.items.2.title",
    desc: "portfolio.items.2.date",
    color: "#3E3A34"
  },
  {
    img: "/excursions/photo24.jpg",
    head: "portfolio.items.2.title",
    desc: "portfolio.items.2.date",
    color: "#F8F4E9"
  },
  {
    img: "/excursions/photo13.jpg",
    head: "portfolio.items.1.title",
    desc: "portfolio.items.1.date",
    color: "#3E3A34"
  },
  {
    img: "/excursions/photo12.jpg",
    head: "portfolio.items.1.title",
    desc: "portfolio.items.1.date",
    color: "#3E3A34"
  },
  {
    img: "/excursions/photo11.jpg",
    head: "portfolio.items.1.title",
    desc: "portfolio.items.1.date",
    color: "#3E3A34"
  },
];

export const reviews = [
  {
    img: "/users/user.svg",
    name: "reviews.1.name",
    excursion: "reviews.1.excursion",
    text: "reviews.1.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.2.name",
    excursion: "reviews.2.excursion",
    text: "reviews.2.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.3.name",
    excursion: "reviews.3.excursion",
    text: "reviews.3.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.4.name",
    excursion: "reviews.4.excursion",
    text: "reviews.4.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.5.name",
    excursion: "reviews.5.excursion",
    text: "reviews.5.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.6.name",
    excursion: "reviews.6.excursion",
    text: "reviews.6.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.7.name",
    excursion: "reviews.7.excursion",
    text: "reviews.7.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.8.name",
    excursion: "reviews.8.excursion",
    text: "reviews.8.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.9.name",
    excursion: "reviews.9.excursion",
    text: "reviews.9.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.10.name",
    excursion: "reviews.10.excursion",
    text: "reviews.10.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.11.name",
    excursion: "reviews.11.excursion",
    text: "reviews.11.text",
  },
  {
    img: "/users/user.svg",
    name: "reviews.12.name",
    excursion: "reviews.12.excursion",
    text: "reviews.12.text",
  },
];

export const excursions = [
  {
    img: "/excursions/monast.jpg",
    name: "excursions.1.title",
    age: "excursions.1.age",
    time: "excursions.1.time",
    route: "excursions.1.route",
    desc: "excursions.1.description",
    price: "excursions.1.price",
    url: "https://tglink.ru/anna_excursion",
  },
  {
    img: "/excursions/kitay.jpg",
    name: "excursions.2.title",
    age: "excursions.2.age",
    time: "excursions.2.time",
    route: "excursions.2.route",
    desc: "excursions.2.description",
    price: "excursions.2.price",
    url: "https://tglink.ru/anna_excursion",
  },
  {
    img: "/excursions/love.jpg",
    name: "excursions.3.title",
    age: "excursions.3.age",
    time: "excursions.3.time",
    route: "excursions.3.route",
    desc: "excursions.3.description",
    price: "excursions.3.price",
    url: "https://experience.tripster.ru/experience/booking/81468/",
  },
  {
    img: "/excursions/prost.jpg",
    name: "excursions.4.title",
    age: "excursions.4.age",
    time: "excursions.4.time",
    route: "excursions.4.route",
    desc: "excursions.4.description",
    price: "excursions.4.price",
    url: "https://experience.tripster.ru/experience/booking/87854/",
  },
  {
    img: "/excursions/red_square.jpg",
    name: "excursions.5.title",
    age: "excursions.5.age",
    time: "excursions.5.time",
    route: "excursions.5.route",
    desc: "excursions.5.description",
    price: "excursions.5.price",
    url: "https://tglink.ru/anna_excursion"
  },
  {
    img: "/excursions/pobeda.jpg",
    name: "excursions.6.title",
    age: "excursions.6.age",
    time: "excursions.6.time",
    route: "excursions.6.route",
    desc: "excursions.6.description",
    price: "excursions.6.price",
    url: "https://tglink.ru/anna_excursion"
  },
  {
    img: "/excursions/paris.jpg",
    name: "excursions.7.title",
    age: "excursions.7.age",
    time: "excursions.7.time",
    route: "excursions.7.route",
    desc: "excursions.7.description",
    price: "excursions.7.price",
    url: "https://tglink.ru/anna_excursion",
    isNew: true
  },
];